<template>
  <div class="container-fluid">
    <div class="row">
      <b-col lg="12">
        <transition name="fade">
          <b-card no-body>
            <div slot="header">
              <i class="fa fa-edit"></i> {{ pageName }}
              <div class="card-header-actions">
                <b-link class="card-header-action btn-minimize" v-b-toggle.collapse1>
                  <i class="icon-arrow-up"></i>
                </b-link>
              </div>
            </div>
            <b-collapse id="collapse1" visible>
              <b-card-body>
                <b-row>
                  <b-col sm="3">
                    <TextBox v-model="item.firstName">First Name</TextBox>
                  </b-col>
                  <b-col sm="3">
                    <TextBox v-model="item.middleName">Middle Name</TextBox>
                  </b-col>
                  <b-col sm="3">
                    <TextBox v-model="item.lastName">Last Name</TextBox>
                  </b-col>
                  <b-col sm="3">
                    <TextBox v-model="item.email">Email</TextBox>
                  </b-col>
                  <b-col sm="3">
                    <TextBox v-model="item.phone">Phone</TextBox>
                  </b-col>
                  <b-col sm="3">
                    <TextBox v-model="item.login">Login</TextBox>
                  </b-col>
                  <b-col sm="3">
                    <TextBox v-model="item.inn">Inn</TextBox>
                  </b-col>
                  <b-col sm="3">
                    <TextBox v-model="item.farmUuid">Farm Uuid</TextBox>
                  </b-col>
                  <b-col sm="3">
                    <TextBox v-model="item.fieldUuid">Field Uuid</TextBox>
                  </b-col>
                </b-row>
                <div class="d-flex justify-content-end">
                  <div class="form-actions">
                    <b-button right type="submit" variant="primary" style="margin-right: 5px;" @click="onSubmit">Save
                    </b-button>
                    <router-link type="cancel" class="btn btn-secondary" variant="secondary"
                                 :to="'/users/list'">Cancel
                    </router-link>
                  </div>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
        </transition>
      </b-col>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'UsersAddEditPage',
    data () {
      return {
        item: {}
      }
    },
    created() {
      if (!this.$route.params.id || this.$route.params.id <= 0) {
        return
      }
      this.axios.get('member/item/' + this.$route.params.id)
          .then(response => {
            this.item = response.data.data
          })
          .catch(error => {
            if (error.response && error.response.data.status === 400) {
              this.$toastr.error(error.response.data.message)
            }
          })
    },
    computed: {
      pageName() {
        return this.$route.params.id ? 'Edit User' : 'Add User'
      }
    },
    methods: {
      onSubmit() {
        let axios
        if (this.$route.params.id) {
          axios = this.axios.put('member/item', this.item)
        } else {
          axios = this.axios.post('member/item', this.item)
        }
        this.$loading.show()
        axios.then((res) => {
          if (res.data && res.data.status === 200) {
            this.$toastr.success(res.data.message)
            this.$router.push('/users/list')
          } else {
            this.$toastr.error(res.data.message)
          }
          this.$loading.hide()
        }).catch((error) => {
          this.$loading.hide()
          if (error.message) {
            this.$toastr.error(error.message)
          }
        })
      }
    }

  };
</script>

<style scoped>

</style>